import React from "react";
import "./terms.css"; 

const Privacy = () => {
  return (
    <div className="terms-page">
      <div className="top-header">
        <div className="header-left">
          <img
            src="/assets/img/InstaTenders - Logo reduced.png"
            alt="InstaTenders Logo"
            className="login-brand-logo"
          />
        </div>
      </div>

      <div className="terms-container">
        <div className="terms-banner">
          <h1>Privacy Policy</h1>
          <p>
            <strong>Effective Date: 1st January 2026</strong>
          </p>
        </div>
        <div className="terms-card">
          <div className="terms-section">
            <h3>Overview</h3>
            <p>
              InstaTenders values your privacy and is committed to protecting
              your business information.
            </p>
          </div>

          <div className="terms-section">
            <h3>1. Information We Collect</h3>
            <p>
              <strong>We may collect:</strong>
            </p>
            <ul>
              <li>Company name</li>
              <li>Contact person details</li>
              <li>Email address</li>
              <li>Phone number</li>
              <li>GST details</li>
              <li>Business address</li>
              <li>Login credentials</li>
              <li>Transaction data</li>
              <li>IP address & device information</li>
            </ul>
          </div>

          <div className="terms-section">
            <h3>2. How We Use Information</h3>
            <p>
              <strong>We use collected information to:</strong>
            </p>
            <ul>
              <li>Create and manage user accounts</li>
              <li>Facilitate procurement transactions</li>
              <li>Display active procurement leads</li>
              <li>Improve platform functionality</li>
              <li>Send notifications and updates</li>
              <li>Provide customer support</li>
            </ul>
          </div>

          <div className="terms-section">
            <h3>3. Information Sharing</h3>
            <p>
              <strong>We may share information:</strong>
            </p>
            <ul>
              <li>Between Buyers and Suppliers for transaction purposes</li>
              <li>With government authorities if required by law</li>
              <li>
                With service providers for hosting, analytics, or payment
                processing
              </li>
              <li>We do NOT sell user data to third parties</li>
            </ul>
          </div>

          <div className="terms-section">
            <h3>4. Data Security</h3>
            <p>
              We implement reasonable technical and organizational security
              measures to protect data. However, no online system is 100%
              secure.
            </p>
          </div>

          <div className="terms-section">
            <h3>5. Data Retention</h3>
            <p>
              <strong>We retain business data as long as:</strong>
            </p>
            <ul>
              <li>The account is active</li>
              <li>Required for legal or regulatory compliance</li>
              <li>Users may request account deletion</li>
            </ul>
          </div>

          <div className="terms-section">
            <h3>6. Cookies & Tracking</h3>
            <p>
              <strong>We may use cookies to:</strong>
            </p>
            <ul>
              <li>Improve user experience</li>
              <li>Track usage analytics</li>
              <li>Maintain login sessions</li>
              <li>Users can disable cookies in browser settings</li>
            </ul>
          </div>

          <div className="terms-section">
            <h3>7. User Rights</h3>
            <p>
              <strong>Users may:</strong>
            </p>
            <ul>
              <li>Request access to their data</li>
              <li>Request correction of inaccurate information</li>
              <li>Request account deletion</li>
              <li>Opt out of marketing communications</li>
            </ul>
          </div>

          <div className="terms-section">
            <h3>8. Third-Party Links</h3>
            <p>
              The platform may contain links to third-party websites.
              InstaTenders is not responsible for their privacy practices.
            </p>
          </div>

          <div className="terms-section">
            <h3>9. Changes to Policy</h3>
            <p>
              We may update this Privacy Policy from time to time. Continued use
              of the platform indicates acceptance of the updated policy.
            </p>
          </div>

          <div className="terms-section">
            <h3>10. Contact Us</h3>
            <p>
              <strong>For any privacy-related concerns, contact:</strong>
            </p>
            <ul>
              <li>
                <strong>Support:</strong> InstaTenders Support
              </li>
              <li>
                <strong>Email:</strong> p.dhanaraj@instatenders.in
              </li>
              <li>
                <strong>Phone:</strong> 9884713801
              </li>
              <li>
                <strong>Address:</strong> 4/159, Thiru.vi.ka Industrial Estate,
                Labour Colony 1st Street, Guindy, Chennai - 600032, Tamil Nadu,
                India
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="custom-footer">
        <div className="footer-top">
          <div className="footer-col left">
            <a href="/privacy">Privacy</a>
            <a href="/terms">Terms & Conditions</a>
            <a href="/refund">Refund Policy</a>
            <a href="/cancellation">Cancellation Policy</a>
          </div>

          <div className="footer-col right">
            <p>
              <span>📍</span> 4/159, Thiru.vi.ka Industrial Estate, Labour
              Colony 1st Street, Guindy, Chennai - 600032, Tamil Nadu, India
            </p>
            <p className="phone">
              <span>📞</span> +91 9884713801
            </p>
          </div>
        </div>

        <div className="footer-bottom">
          Copyright © 2026. All Rights Reserved
        </div>
      </div>
    </div>
  );
};

export default Privacy;
